import { render, staticRenderFns } from "./btn-contact.mpx?vue&type=template&id=378bc985&isComponent&outputPath=components%2Fbtn-contact7fcf1775%2Findex"
import script from "./btn-contact.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-contact7fcf1775%2Findex"
export * from "./btn-contact.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-contact7fcf1775%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports